import { type ZendeskSettings } from 'types/zendeskWidget';

export const DEFAULT_ZENDESK_SETTINGS: ZendeskSettings = {
  webWidget: {
    launcher: {
      chatLabel: {
        '*': 'Help chat',
        es: 'Chat de ayuda',
        'es-es': 'Chat de ayuda',
        'es-419': 'Chat de ayuda',
      },
    },
    color: {
      theme: '#7145D6',
      button: '#262645',
    },
    chat: {
      connectOnPageLoad: false,
      concierge: {
        name: 'Live Support',
        avatarPath:
          'https://assets.cabifil.es/images/logos_cabify/lo_cabify_avatar.svg',
        title: {
          '*': 'Customer Support',
        },
      },
      title: {
        '*': 'Chat with us',
        es: 'Chatea con nosotros',
        'es-es': 'Chatea con nosotros',
        'es-419': 'Chatea con nosotros',
      },
      hideWhenOffline: true,
      suppress: true,
    },
    contactForm: {
      suppress: true,
    },
    answerBot: {
      suppress: true,
    },
    contactOptions: {
      enabled: false,
    },
    helpCenter: {
      suppress: true,
    },
    talk: {
      suppress: true,
    },
  },
};
